{
  "close": "Fermer",
  "notifications": "Notifications"
}
